// --- React
import React from 'react';
// --- UI Components
import { Col, Row } from 'antd';
import Typography from '@dtci/spellbook/Typography';
// --- Utils
import { getNielsenDetails } from '../utils/getDetailsData';
// --- Styles
import '../../styles.scss';

/**
 * NielsenCard Component
 *
 * This component is responsible for rendering a card that displays detailed
 * information about a product's Nielsen data.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.details - The details of the product to be displayed.
 * @returns {ReactElement} Nielsen card with detailed information.
 */
export function NielsenCard({ details }) {
    // Function to extract Nielsen details from the provided data
    const nielsenDetails = getNielsenDetails(details);

    return (
        <Row style={{ marginTop: 20 }}>
            <Col>
                {nielsenDetails.map(({ label, value }, idx) => (
                    <Row key={`nielsen-${idx}`}>
                        <Typography variant="T20">
                            <b>{label}:</b>
                            <br />
                            {value}
                        </Typography>
                    </Row>
                ))}
            </Col>
        </Row>
    );
}
